import { Component, OnInit, Renderer, ViewChild, ElementRef, Directive, OnDestroy, Input } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { filter } from 'rxjs/operators';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { GlobalService } from 'src/app/services/global.service';
import { MatDialog } from '@angular/material';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { Funcionario } from './../../models/funcionario';
import { FuncionarioService } from 'src/app/services/funcionario.service';
import { UsuarioLogado } from 'src/app/models/usuario-logado';
import { TipoSistema } from 'src/app/models/enum';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { GI_ROUTES } from 'src/app/sidebar/sidebar.component';
import { Notificacao } from 'src/app/models/notificacao';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { ObservacoesModalComponent } from 'src/app/modals/observacoes-modal/observacoes-modal.component';
import { CotacaoService } from 'src/app/services/cotacao.service';
import { PremissasService } from 'src/app/services/premissas.service';
import { FidelidadeMovimentaService } from 'src/app/services/fidelidade-movimenta.service';
import swal from 'sweetalert2';
import { VisualizadorPdfComponent } from 'src/app/visualizador-pdf/visualizador-pdf.component';
import { TokenPlataformaModalComponent } from 'src/app/modals/token-plataforma-modal/token-plataforma-modal.component';
import { NotificacaoAtributos } from 'src/app/models/notificacao-atributos';
import { SolicitacoesTokenIntegradorModalComponent } from 'src/app/modals/solicitacoes-token-integrador-modal/solicitacoes-token-integrador-modal.component';
import { PremissasSistema } from 'src/app/models/premissas-sistema';
import { AnaliseDescontoSolicitacaoModalComponent } from 'src/app/modals/analise-desconto-solicitacao-modal/analise-desconto-solicitacao-modal.component';
import { SegmentacaoService } from 'src/app/services/segmentacao.service';
import { Segmentacao } from 'src/app/models/segmentacao';
import { ClienteService } from 'src/app/services/cliente.service';
import { NotificacaoServiceV2 } from '../../notificacao/services/notificacao-service-v2';
import { BehaviorSubject } from 'rxjs';
import { NtfSumarioNotificacaoModel } from '../../notificacao/models/ntf-sumario-notificacao-model';
import { NotificacaoSignalr } from '../../notificacao/services/notificacao.signalr';
import { TermoAceiteListaModalComponent } from '../../modals/termo-aceite-lista-modal/termo-aceite-lista-modal.component';
import { TipoSituacaoCadastral } from 'src/app/dominio/enums';
import { QueryFilterService } from 'src/app/core/services/query-filter-service';
import { LojaConfigService } from 'src/app/loja-gi/services/loja-config.service';
import { GiLojaModel } from 'src/app/dominio/gi-loja-model';

const misc: any = {
  navbar_menu_visible: 0,
  active_collapse: true,
  disabled_collapse_init: 0
};

declare let $: any;
@Component({
  selector: 'app-navbar-cmp',
  templateUrl: 'navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit, OnDestroy {
  tipoSistema: TipoSistema = TipoSistema.GI;

  private listTitles: any[];
  location: Location;
  mobile_menu_visible: any = 0;
  private nativeElement: Node;
  private toggleButton: any;
  private sidebarVisible: boolean;
  private _router: Subscription;
  usuarioLogado: UsuarioLogado = new UsuarioLogado();
  administrador = false;
  notificacoes: Notificacao[] = [];
  private minimizarMenu$: Subscription;
  public config: PerfectScrollbarConfigInterface = {};
  integrador = false;
  cotacaoDolarPTAX: number;
  cotacaoDolar: number;
  dolarSubiu: boolean = false;
  mostrarCotacao = false;

  textoFidelidade = '';
  fidelidadeGoSolar = false;
  fidelidadeMovimentacao = false;

  pontuacaoFidelidadeMovimentacao = 0;

  exibirCotacao = false;
  idIntegrador;

  nomeDaTela = '';
  urlAtual = '';
  modulosAtivos: Number[] = [];
  podeGerarToken: boolean = false;
  possuiModuloGestao = false;

  premissasSistema: PremissasSistema;

  classificacao: Segmentacao = new Segmentacao();
  imagemClassificacaoDisponivel: boolean = false;

  private sumarioNotificacaoSubscription: Subscription;
  sumarioNotificacao: NtfSumarioNotificacaoModel = { totalNaoLidas: 0 };

  lojas: GiLojaModel[] = [];

  @ViewChild('app-navbar-cmp', { static: false }) button: any;

  constructor(
    location: Location,
    private renderer: Renderer,
    private element: ElementRef,
    private router: Router,
    private globalService: GlobalService,
    public dialog: MatDialog,
    private notificacaoService: NotificacaoService,
    private notificacaoSignalr: NotificacaoSignalr,
    private notificacaoServiceV2: NotificacaoServiceV2,
    private carregandoService: CarregandoService,
    private funcionarioService: FuncionarioService,
    private utilitarioService: UtilitarioService,
    private cotacaoService: CotacaoService,
    private premissasService: PremissasService,
    private fidelidadeMovimentaService: FidelidadeMovimentaService,
    private activatedRoute: ActivatedRoute,
    private clienteService: ClienteService,
    private queryFilterService: QueryFilterService,
    private lojaConfigService: LojaConfigService
  ) {
    this.location = location;
    this.nativeElement = element.nativeElement;
    this.sidebarVisible = false;
  }

  async ngOnInit() {
    this.administrador = await this.globalService.administrador();
    this.usuarioLogado = await this.globalService.consultaUsuario();
    this.integrador = await this.globalService.integrador();
    this.idIntegrador = this.usuarioLogado.id;

    await this.buscarPremissasSistema();
    this.buscarMostrarCotacaoDolar();

    this.sumarioNotificacaoSubscription = this.notificacaoSignalr.ntfSumarioNotificacaoSubject.subscribe((data) => {
      if (!data) {
        this.buscarSumarioNotificacoes();
      } else {
        this.sumarioNotificacao = data;
      }
    });

    this.minimizarMenu$ = this.globalService.minimizarMenuBS.subscribe((minimizar) => {
      if (minimizar && misc && !misc.sidebar_mini_active) {
        this.minimizeSidebar();
      }
    });

    await this.buscarModulosAtivos();
    this.buscaIntegracaoPlataforma();

    if (this.integrador) {
      this.buscarClassificacaoIntegrador();
    }

    if (this.premissasSistema.usarLojaProdutos) {
      await this.buscarLojas();
    }

    this.listTitles = GI_ROUTES;
    this.urlAtual = this.getPath();
    this.nomeDaTela = await this.getTitle(this.urlAtual);

    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(async (event: NavigationEnd) => {
        this.urlAtual = event.url;
        this.nomeDaTela = await this.getTitle(event.url);
      });

    const navbar: HTMLElement = this.element.nativeElement;
    const body = document.getElementsByTagName('body')[0];
    this.toggleButton = navbar.getElementsByClassName('navbar-toggler')[0];
    if (body.classList.contains('sidebar-mini')) {
      misc.sidebar_mini_active = true;
    }
    if (body.classList.contains('hide-sidebar')) {
      misc.hide_sidebar_active = true;
    }
    this._router = this.router.events
      .filter((event) => event instanceof NavigationEnd)
      .subscribe((event: NavigationEnd) => {
        this.sidebarClose();

        const $layer = document.getElementsByClassName('close-layer')[0];
        if ($layer) {
          $layer.remove();
        }
      });

    if (this.mostrarCotacao) {
      this.buscarValorCotacaoDolarPTAX();

      setInterval(() => {
        this.buscarValorCotacaoDolarPTAX();
      }, 180000);
    }

    this.buscarTextoFidelidade();
    this.buscarPontuacaoFidelidadeMovimentacao();
  }

  async buscarClassificacaoIntegrador() {
    this.carregandoService.mostra('buscarClassInt');
    try {
      const data = await this.clienteService.consultarClassificacaoIntegrador(this.idIntegrador).toPromise();
      this.classificacao = data.result.result;

      this.imagemClassificacaoDisponivel = false;

      if (this.classificacao != null) {
        try {
          const imagem = await this.clienteService.consultarImagemPorId(this.classificacao.id).toPromise();
          const base64 = this.utilitarioService.toBase64ComInicio(imagem);
          this.classificacao.imagem$ = Promise.resolve(base64);
          this.imagemClassificacaoDisponivel = true;
        } catch (erroImg) {
          console.log('Erro ao buscar imagem:', erroImg);
          this.imagemClassificacaoDisponivel = false;
        }
      }
    } catch (erro) {
      console.log('Erro ao buscar classificação:', erro);
    } finally {
      this.carregandoService.esconde('buscarClassInt');
    }
  }

  async buscarPremissasSistema() {
    try {
      this.carregandoService.mostra('buscarPremissasSistema');
      this.premissasSistema = await this.premissasService.consultarPremissasSistema().toPromise();
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarPremissasSistema');
    }
  }

  buscaIntegracaoPlataforma() {
    this.carregandoService.mostra('mostraPlaforma');
    this.premissasService.consultarIntegracaoPlataforma().subscribe(
      (data) => {
        this.podeGerarToken = data.valor;
        this.carregandoService.esconde('mostraPlaforma');
      },
      (erro) => {
        this.carregandoService.esconde('mostraPlataforma');
        this.notificacaoService.erro(erro);
      }
    );
  }

  possuiModulo(modulo: Number) {
    return this.modulosAtivos.some((p) => p === modulo);
  }

  async buscarModulosAtivos() {
    try {
      this.carregandoService.mostra('buscarModulosAtivos');

      this.modulosAtivos = await this.premissasService.consultarModulosAtivos().toPromise();

      this.possuiModuloGestao = this.possuiModulo(2);

      this.carregandoService.esconde('buscarModulosAtivos');
    } catch (erro) {
      this.carregandoService.esconde('buscarModulosAtivos');
      this.notificacaoService.erro(erro);
    }
  }

  minimizeSidebar() {
    const body = document.getElementsByTagName('body')[0];

    if (misc.sidebar_mini_active === true) {
      body.classList.remove('sidebar-mini');
      misc.sidebar_mini_active = false;
    } else {
      setTimeout(function () {
        body.classList.add('sidebar-mini');

        misc.sidebar_mini_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  hideSidebar() {
    const body = document.getElementsByTagName('body')[0];
    const sidebar = document.getElementsByClassName('sidebar')[0];

    if (misc.hide_sidebar_active === true) {
      setTimeout(function () {
        body.classList.remove('hide-sidebar');
        misc.hide_sidebar_active = false;
      }, 300);
      setTimeout(function () {
        sidebar.classList.remove('animation');
      }, 600);
      sidebar.classList.add('animation');
    } else {
      setTimeout(function () {
        body.classList.add('hide-sidebar');
        // $('.sidebar').addClass('animation');
        misc.hide_sidebar_active = true;
      }, 300);
    }

    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);
  }

  onResize(event) {
    if ($(window).width() > 991) {
      return false;
    }
    return true;
  }

  sidebarOpen() {
    let $toggle = document.getElementsByClassName('navbar-toggler')[0];
    const toggleButton = this.toggleButton;
    const body = document.getElementsByTagName('body')[0];
    setTimeout(function () {
      toggleButton.classList.add('toggled');
    }, 500);
    body.classList.add('nav-open');
    setTimeout(function () {
      $toggle.classList.add('toggled');
    }, 430);

    let $layer = document.createElement('div');
    $layer.setAttribute('class', 'close-layer');

    if (body.querySelectorAll('.main-panel')) {
      document.getElementsByClassName('main-panel')[0].appendChild($layer);
    } else if (body.classList.contains('off-canvas-sidebar')) {
      document.getElementsByClassName('wrapper-full-page')[0].appendChild($layer);
    }

    setTimeout(function () {
      $layer.classList.add('visible');
    }, 100);

    $layer.onclick = function () {
      //asign a function
      body.classList.remove('nav-open');
      this.mobile_menu_visible = 0;
      this.sidebarVisible = false;

      $layer.classList.remove('visible');
      setTimeout(function () {
        $layer.remove();
        $toggle.classList.remove('toggled');
      }, 400);
    }.bind(this);

    body.classList.add('nav-open');
    this.mobile_menu_visible = 1;
    this.sidebarVisible = true;
  }

  buscarMostrarCotacaoDolar() {
    this.carregandoService.mostra('buscarMostarDolar');
    this.premissasService.consultarMostrarCotacaoDolar().subscribe(
      (ctd) => {
        if (ctd.valor) {
          this.mostrarCotacao = ctd.valor;
        }
        this.carregandoService.esconde('buscarMostarDolar');
      },
      (erro) => {
        this.carregandoService.esconde('buscarMostarDolar');
        this.notificacaoService.erro(erro);
      }
    );
  }

  sidebarClose() {
    let $toggle = document.getElementsByClassName('navbar-toggler')[0];
    const body = document.getElementsByTagName('body')[0];
    this.toggleButton.classList.remove('toggled');
    let $layer = document.createElement('div');
    $layer.setAttribute('class', 'close-layer');

    this.sidebarVisible = false;
    body.classList.remove('nav-open');
    // $('html').removeClass('nav-open');
    body.classList.remove('nav-open');
    if ($layer) {
      $layer.remove();
    }

    setTimeout(function () {
      $toggle.classList.remove('toggled');
    }, 400);

    this.mobile_menu_visible = 0;
  }

  sidebarToggle() {
    if (this.sidebarVisible === false) {
      this.sidebarOpen();
    } else {
      this.sidebarClose();
    }
  }

  buscarValorCotacaoDolarPTAX() {
    const subscription = this.cotacaoService.consultarDolarPTAX().subscribe(
      ({ value: cotacoesDolarPTAX }) => {
        if (cotacoesDolarPTAX.length) {
          const ultimo = cotacoesDolarPTAX[cotacoesDolarPTAX.length - 1];
          const penultimo = cotacoesDolarPTAX[cotacoesDolarPTAX.length - 2];

          if (ultimo.cotacaoCompra > penultimo.cotacaoCompra) {
            this.dolarSubiu = true;
          }

          this.cotacaoDolarPTAX = ultimo.cotacaoCompra;
        }

        this.buscarValorCotacaoDolar();
      },
      (erro) => {
        // this.notificacaoService.erro(erro);
      }
    );

    setTimeout(() => subscription.unsubscribe(), 5000);
  }

  buscarValorCotacaoDolar() {
    const subscription = this.cotacaoService.consultarDolarAtual().subscribe(
      ({ value: cotacoesDolar }) => {
        if (cotacoesDolar.length) {
          const ultimo = cotacoesDolar[cotacoesDolar.length - 1];

          if (cotacoesDolar.length > 1) {
            const penultimo = cotacoesDolar[cotacoesDolar.length - 2];

            if (ultimo.cotacaoCompra > penultimo.cotacaoCompra) {
              this.dolarSubiu = true;
            }
          }

          this.cotacaoDolar = ultimo.cotacaoCompra;
        }
      },
      (erro) => {
        // this.notificacaoService.erro(erro);
      }
    );

    setTimeout(() => subscription.unsubscribe(), 5000);
  }

  buscarTextoFidelidade() {
    this.carregandoService.mostra('textoFidelidade');
    this.premissasService.textoFidelidade().subscribe(
      (vars) => {
        this.textoFidelidade = vars.texto;

        this.carregandoService.esconde('textoFidelidade');
      },
      (erro) => {
        this.carregandoService.esconde('textoFidelidade');
        this.notificacaoService.erro(erro);
      }
    );
  }

  async getTitle(url?: string): Promise<string> {
    let titlee = url !== undefined ? url : this.location.prepareExternalUrl(this.location.path());

    if (titlee.charAt(0) === '#') {
      titlee = titlee.slice(1);
    }

    if (titlee === '/kitpersonalizado') {
      return 'Personalize seu kit';
    }

    if (titlee.includes('/configuracoes')) {
      return 'Configurações';
    }

    if (titlee.startsWith('/loja-de-produtos/')) {
      const idLoja = Number(titlee.substring(titlee.lastIndexOf('/') + 1));
      if (this.lojas.some((p) => p.id === idLoja)) {
        return this.lojas.find((p) => p.id === idLoja).nome;
      } else {
        return 'Loja de Produtos';
      }
    }

    if (this.listTitles !== null && this.listTitles !== undefined) {
      for (let i = 0; i < this.listTitles.length; i++) {
        if (this.listTitles[i].type === 'link' && this.listTitles[i].path === titlee) {
          return this.listTitles[i].hint ? this.listTitles[i].hint : this.listTitles[i].title;
        } else if (this.listTitles[i].type === 'sub') {
          for (let j = 0; j < this.listTitles[i].children.length; j++) {
            let subtitle = this.listTitles[i].path + '/' + this.listTitles[i].children[j].path;
            if (subtitle === titlee) {
              return this.listTitles[i].children[j].hint
                ? this.listTitles[i].children[j].hint
                : this.listTitles[i].children[j].title;
            }
          }
        }
      }
    }

    if (this.location.path().includes('proibido')) {
      return 'Oops';
    }

    const textoFilho = $('.sidebar .active .nav .active .nav-link .sidebar-normal').text();

    if (textoFilho) {
      return textoFilho;
    } else {
      return $('.sidebar .active .nav-link p').text();
    }

    // return 'Dashboard';
  }

  getPath(): string {
    const fullPath = this.router.url;
    const baseUrl = this.router.url.split('/')[0];
    return fullPath.replace(baseUrl, '');
  }

  buscarSumarioNotificacoes() {
    this.notificacaoServiceV2.buscarSumario().subscribe(
      (data) => {
        this.sumarioNotificacao = data.result;
      },
      (erro) => {
        this.notificacaoService.erro(erro);
      }
    );
  }

  buscarPontuacaoFidelidadeMovimentacao() {
    this.carregandoService.mostra('buscarPontuacaoFidelidadeMovimentacao');
    this.premissasService.consultarUsarFidelidade().subscribe(
      (UsarFidelidade) => {
        if (UsarFidelidade.valor) {
          this.fidelidadeMovimentacao = true;

          this.carregandoService.mostra('buscarPontuacaoFidelidadeMovimentacao');
          this.fidelidadeMovimentaService.consultarSaldo().subscribe(
            (pontuacao) => {
              this.pontuacaoFidelidadeMovimentacao = pontuacao;
              this.carregandoService.esconde('buscarPontuacaoFidelidadeMovimentacao');
            },
            (erro) => {
              this.carregandoService.esconde('buscarPontuacaoFidelidadeMovimentacao');
              this.notificacaoService.erro(erro);
            }
          );
        }

        this.carregandoService.esconde('buscarPontuacaoFidelidadeMovimentacao');
      },
      (erro) => {
        this.carregandoService.esconde('buscarPontuacaoFidelidadeMovimentacao');
        this.notificacaoService.erro(erro);
      }
    );
  }

  conversarPeloWhatsapp() {
    this.carregandoService.mostra('conversarPeloWhatsapp');
    this.funcionarioService.ConsultarVendedorDoIntegrador().subscribe(
      (vendedor: Funcionario) => {
        this.utilitarioService.conversarPeloWhatsapp(vendedor.celular, '');

        this.carregandoService.esconde('conversarPeloWhatsapp');
      },
      (erro) => {
        this.carregandoService.esconde('conversarPeloWhatsapp');
        this.notificacaoService.erro(erro);
      }
    );
  }

  ngOnDestroy(): void {
    if (this.sumarioNotificacaoSubscription) {
      this.sumarioNotificacaoSubscription.unsubscribe();
    }
  }

  exibirObservacoes(idCupom) {
    const largura = Number($('body').width());

    const dialogRef = this.dialog.open(ObservacoesModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: { idCupom: idCupom },
      panelClass: 'modal-card'
    });

    dialogRef.afterClosed().subscribe((result) => {
      // if (result) {
      //   this.buscarPedidos();
      // }
    });
  }

  exibirModalAnaliseDesconto(idCupom) {
    const dialogRef = this.dialog.open(AnaliseDescontoSolicitacaoModalComponent, {
      width: '1078px',
      data: {
        idCupom: idCupom
      },
      panelClass: ['modal-card', 'modal-card-v2']
    });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (result) {
      }
    });
  }

  exibirAnaliseDesconto(id) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['analise-desconto'], {
        state: {
          idFilaTarefa: id
        }
      });
    });
  }

  exibirOcorrencia(id) {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate(['controle-ocorrencia/lancamento'], {
        state: {
          veioDoModal: false,
          idOcorrencia: id
        }
      });
    });
  }

  exibirSolicitacaoToken(idSolicitacaoToken) {
    const largura = Number($('body').width());

    this.dialog.open(SolicitacoesTokenIntegradorModalComponent, {
      width: largura > 1050 ? '1000px' : $('body').width().toString() + 'px',
      data: { idSolicitacaoToken },
      panelClass: 'modal-card'
    });
  }

  abrirModalToken() {
    const largura = Number($('body').width());

    this.dialog.open(TokenPlataformaModalComponent, {
      width: largura > 970 ? '370px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card'
    });
  }

  abrirModalAceiteTermo() {
    const largura = Number($('body').width());

    this.dialog.open(TermoAceiteListaModalComponent, {
      width: largura > 970 ? '870px' : $('body').width().toString() + 'px',
      panelClass: 'modal-card'
    });
  }

  async buscarLojas() {
    try {
      this.carregandoService.mostra('buscarLojas');

      const queryFilter = this.queryFilterService
        .getQueryBuilder()
        .addCondition('situacao', '=', TipoSituacaoCadastral.Ativo)
        .build();

      this.lojas = (await this.lojaConfigService.buscarTodos(queryFilter).toPromise()).results;
    } catch (erro) {
      this.notificacaoService.erro(erro);
    } finally {
      this.carregandoService.esconde('buscarLojas');
    }
  }
}
